/**
 * Inglés. Cada clave es la frase tal como está escrita en español en el
 * código; lo que falte aquí se ve en español (ver src/lib/i18n.ts).
 */
const en: Record<string, string> = {
  // Menú y cabecera
  'Abrir menú': 'Open menu',
  'Cerrar menú': 'Close menu',
  'Buscar jugadores': 'Search players',
  'Buscar…': 'Search…',
  'Entrar': 'Sign in',
  'Crear cuenta': 'Sign up',
  'Cambiar a modo día': 'Switch to light mode',
  'Cambiar a modo noche': 'Switch to dark mode',
  'Modo día': 'Light mode',
  'Modo noche': 'Dark mode',
  'Mi perfil': 'My profile',
  'Ajustes': 'Settings',
  'Instalar la aplicación': 'Install the app',
  'Moderación': 'Moderation',
  'Cerrar sesión': 'Sign out',
  'Reconectando con el servidor…': 'Reconnecting to the server…',
  'Términos de uso': 'Terms of use',
  'Preguntas frecuentes': 'FAQ',
  'Idioma': 'Language',

  'Jugar': 'Play',
  'Crear partida en la sala de espera': 'Create a game in the lobby',
  'Desafía a un amigo': 'Challenge a friend',
  'Torneos': 'Tournaments',
  'Torneos suizos': 'Swiss tournaments',
  'Partidas simultáneas': 'Simultaneous exhibitions',
  'Tablero local': 'Over the board',
  'Ejercicios': 'Puzzles',
  'Ejercicios por temas': 'Puzzle themes',
  'Panel de ejercicios': 'Puzzle dashboard',
  'Racha': 'Streak',
  'Tormenta': 'Storm',
  'Carrera': 'Racer',
  'Maratón': 'Marathon',
  'De mis partidas': 'From my games',
  'Aprender': 'Learn',
  'Practicar': 'Practice',
  'Coordenadas': 'Coordinates',
  'Estudiar': 'Study',
  'Entrenadores': 'Coaches',
  'Ver': 'Watch',
  'UAChess TV': 'UAChess TV',
  'Partidas actuales': 'Current games',
  'Retransmisiones': 'Broadcasts',
  'Biblioteca de vídeos': 'Video library',
  'Comunidad': 'Community',
  'Comunidades': 'Communities',
  'Clasificación': 'Leaderboard',
  'Foro': 'Forum',
  'Blog': 'Blog',
  'Herramientas': 'Tools',
  'Tablero de análisis': 'Analysis board',
  'Aperturas': 'Openings',
  'Editor de tablero': 'Board editor',
  'Pareo de torneos': 'Tournament pairings',
  'Reloj de ajedrez': 'Chess clock',
  'Importar partida': 'Import game',
  'Búsqueda avanzada': 'Advanced search',
  'Inicio': 'Home',
  'Táctica': 'Puzzles',
  'Estudios': 'Studies',
  'TV': 'TV',

  // Portada
  'Juega al ajedrez. En serio.': 'Play chess. Seriously.',
  'Partidas en todos los ritmos, análisis con motor, estudios, táctica por temas, torneos y comunidades con sus propias ligas. Gratis y sin anuncios.':
    'Games at every time control, engine analysis, studies, themed puzzles, tournaments and communities with their own leagues. Free and ad-free.',
  'Crear cuenta gratis': 'Create a free account',
  'Ya tengo cuenta': 'I already have an account',
  'Todos los ritmos': 'Every time control',
  'Desde UltraBullet de 15 segundos hasta correspondencia de 14 días, con incremento Fischer, Bronstein o retardo simple.':
    'From 15-second UltraBullet to 14-day correspondence, with Fischer increment, Bronstein or simple delay.',
  'Análisis de verdad': 'Real analysis',
  'Motor Stockfish en tu navegador: evaluación, mejores líneas e informe de precisión de cada partida.':
    'Stockfish in your browser: evaluation, best lines and an accuracy report for every game.',
  'Táctica a medida': 'Tailored puzzles',
  'Entrena por temas concretos (clavadas, horquillas, mates) o en modo mixto ajustado a tu nivel.':
    'Train specific themes (pins, forks, mates) or a mix adjusted to your level.',
  'Crea capítulos con variantes, anotaciones y flechas, y compártelos o edítalos en equipo.':
    'Build chapters with variations, comments and arrows, and share them or edit them as a team.',
  'Mira en directo las mejores partidas en curso y las rondas de los torneos importantes.':
    'Watch the best ongoing games and the rounds of major tournaments live.',
  'Comunidades y ligas': 'Communities and leagues',
  'Monta tu club con sus propios torneos, temporadas y clasificación interna.':
    'Start your club with its own tournaments, seasons and internal ranking.',
  'Hola, {name}': 'Hi, {name}',
  '¿Qué te apetece hoy?': 'What do you feel like today?',
  'Jugar una partida': 'Play a game',
  'Busca rival o reta a un amigo.': 'Find an opponent or challenge a friend.',
  'Entrenar táctica': 'Train tactics',
  'Por temas o mixto.': 'By theme or mixed.',
  'Analizar': 'Analyse',
  'Revisa una posición o una partida.': 'Review a position or a game.',
  'Partidas en directo.': 'Live games.',
  'Prepara aperturas y finales.': 'Prepare openings and endgames.',
  'Clubes, ligas y torneos propios.': 'Clubs, leagues and their own tournaments.',
  'Jugar ahora': 'Play now',
  'Contra el ordenador': 'Against the computer',
  'Retar a un amigo': 'Challenge a friend',
  'Más ritmos y la sala de espera': 'More time controls and the lobby',
  'Curso De Zero a Hero.': 'The Zero to Hero course.',
  'Blitz': 'Blitz',
  'Tus ratings': 'Your ratings',

  // Entrar y crear cuenta
  'Vuelve al tablero donde lo dejaste.': 'Get back to the board where you left off.',
  '¿Aún no tienes cuenta?': "Don't have an account yet?",
  'Crear una gratis': 'Create one for free',
  'Usuario o correo': 'Username or email',
  'Contraseña': 'Password',
  'Entrando…': 'Signing in…',
  'No se pudo iniciar sesión. Inténtalo de nuevo.': 'Could not sign in. Please try again.',
  'Continuar con Google': 'Continue with Google',
  'o con tu cuenta': 'or with your account',
  'Mostrar contraseña': 'Show password',
  'Ocultar contraseña': 'Hide password',
  'Gratis y para siempre. Sin anuncios ni tableros de pago.': 'Free forever. No ads, no paid boards.',
  '¿Ya tienes cuenta?': 'Already have an account?',
  'Nombre de usuario': 'Username',
  'Disponible': 'Available',
  'No disponible': 'Not available',
  'No disponible.': 'Not available.',
  'De 2 a 20 caracteres. Empieza por una letra.': '2 to 20 characters. Must start with a letter.',
  'Correo electrónico': 'Email',
  'País': 'Country',
  'Sale junto a tu nombre y en las clasificaciones. Puedes dejarlo sin decir.':
    'Shown next to your name and in leaderboards. You can leave it blank.',
  'Mínimo 8 caracteres.': 'At least 8 characters.',
  'Creando cuenta…': 'Creating account…',
  'No se pudo crear la cuenta. Inténtalo de nuevo.': 'Could not create the account. Please try again.',
  'Al crear la cuenta aceptas los': 'By creating an account you accept the',
  'términos de uso': 'terms of use',
  'Muy débil': 'Very weak',
  'Débil': 'Weak',
  'Aceptable': 'Fair',
  'Buena': 'Good',
  'Excelente': 'Excellent',

  // Ajustes
  'Necesitas una cuenta': 'You need an account',
  'Inicia sesión para guardar tus ajustes en todos tus dispositivos.':
    'Sign in to save your settings across all your devices.',
  'Perfil público': 'Public profile',
  'Avatar ilustrado': 'Illustrated avatar',
  'Foto de perfil activa': 'Active profile photo',
  'Avatar ilustrado activo': 'Active illustrated avatar',
  'Avatar actual': 'Current avatar',
  'En uso': 'In use',
  'Avatar diseñado': 'Custom avatar ready',
  'Sin avatar creado': 'No custom avatar yet',
  'Los demás jugadores ven tu fotografía.': 'Other players see your photo.',
  'Los demás jugadores ven tu avatar ilustrado.': 'Other players see your illustrated avatar.',
  'Personaliza tu perfil público, aspecto del tablero, preferencias y seguridad.': 'Customize your public profile, board appearance, preferences, and security.',
  'Esta información será visible para otros jugadores en tu perfil público y partidas.': 'This information will be visible to other players on your public profile and games.',
  'Personaliza la textura del tablero y el estilo de las piezas. Los cambios se aplican al instante en todas tus partidas.': 'Customize the board texture and piece style. Changes apply instantly to all your games.',
  'Configura los avisos, ayudas visuales y comportamiento durante tus partidas.': 'Configure notifications, visual aids, and game behavior.',
  'Idioma y tema': 'Language & theme',
  'Configura el aspecto visual general y el idioma de la aplicación.': 'Configure the overall visual appearance and app language.',
  'Título federado': 'Federated title',
  'Seguridad': 'Security',
  'Seguridad y contraseña': 'Security & password',
  'Actualiza tu clave de acceso periódicamente para mantener tu cuenta protegida.': 'Update your password periodically to keep your account secure.',
  'Guardar cambios': 'Save changes',
  'Avatar': 'Avatar',
  'Editar mi avatar': 'Edit my avatar',
  'Crear mi avatar': 'Create my avatar',
  'Elige piel, peinado, ropa y accesorios.': 'Choose skin, hairstyle, clothes and accessories.',
  'Volver a mi avatar personalizado': 'Go back to my custom avatar',
  // Foto de perfil
  'Elige una imagen.': 'Choose an image.',
  'No se pudo guardar la foto. Inténtalo otra vez.': 'The photo could not be saved. Try again.',
  'No se pudo quitar la foto.': 'The photo could not be removed.',
  'Tu foto de perfil': 'Your profile photo',
  'Usar una foto': 'Use a photo',
  'Sube una imagen o hazte una foto con la cámara.': 'Upload an image or take a photo with your camera.',
  'Subir foto': 'Upload photo',
  'Hacer foto': 'Take photo',
  'Quitar foto': 'Remove photo',
  'No hay permiso para usar la cámara. Actívalo en el navegador o sube una foto.': 'No permission to use the camera. Allow it in your browser or upload a photo.',
  'Encuadra tu foto': 'Frame your photo',
  'No se pudo abrir esa imagen. Prueba con un JPG o PNG.': 'That image could not be opened. Try a JPG or PNG.',
  'Zoom': 'Zoom',
  'Arrastra la foto para colocarla dentro del círculo.': 'Drag the photo to place it inside the circle.',
  'Cancelar': 'Cancel',
  'Usar esta foto': 'Use this photo',
  'Cerrar': 'Close',
  '¿Sin foto? Usa tu avatar:': 'No photo? Use your avatar:',
  'Al guardar, este avatar sustituirá a tu foto.': 'When you save, this avatar will replace your photo.',
  'O usa un emoji:': 'Or use an emoji:',
  'Nombre': 'Name',
  '(opcional)': '(optional)',
  'Cómo te llamas': 'Your name',
  'Ciudad o región': 'City or region',
  'Por ejemplo: Santiago': 'For example: Santiago',
  'Biografía': 'Bio',
  'Cuéntale algo al resto de jugadores.': 'Tell other players something about you.',
  'Guardando…': 'Saving…',
  'Guardar': 'Save',
  'Guardado.': 'Saved.',
  'No se pudo guardar.': 'Could not save.',
  'Se guarda en este dispositivo. Las partes que aún no están traducidas se ven en español.':
    'Saved on this device. Parts that are not translated yet are shown in Spanish.',
  'Modo de color': 'Color mode',
  'Se guarda en este dispositivo.': 'Saved on this device.',
  'Como el sistema': 'Same as system',
  'Día': 'Light',
  'Noche': 'Dark',
  'Aspecto del tablero': 'Board appearance',
  'Los cambios se aplican al instante en todas tus partidas.': 'Changes apply instantly to all your games.',
  'Preferencias de juego': 'Game preferences',
  'Sonidos': 'Sounds',
  'Jugadas, capturas, jaque y aviso de tiempo.': 'Moves, captures, check and low-time warning.',
  'Vibración': 'Vibration',
  'Respuesta háptica en el móvil al mover.': 'Haptic feedback on your phone when moving.',
  'Resaltar la última jugada': 'Highlight the last move',
  'Mostrar jugadas legales': 'Show legal moves',
  'Puntos en las casillas a las que puede ir la pieza elegida.': 'Dots on the squares the selected piece can move to.',
  'Barra de evaluación': 'Evaluation bar',
  'Jugadores de la casa': 'House players',
  'Si nadie acepta tu búsqueda en unos segundos, emparejarte con una cuenta de UAChess que mueve un programa de ajedrez. Desactívalo para jugar solo contra personas.':
    'If nobody accepts your seek within a few seconds, pair you with a UAChess account played by a chess program. Turn it off to play only against people.',
  'Confirmar antes de rendirse': 'Confirm before resigning',
  'Décimas de segundo en el reloj': 'Tenths of a second on the clock',
  'Se muestran cuando queda menos de un minuto.': 'Shown when less than a minute is left.',
  'Velocidad de las animaciones': 'Animation speed',
  'Sin animación': 'No animation',
  'Rápida': 'Rapid',
  'Rápido': 'Fast',
  'Normal': 'Normal',
  'Lenta': 'Slow',
  'Coordenadas del tablero': 'Board coordinates',
  'Dentro de las casillas': 'Inside the squares',
  'Fuera del tablero': 'Outside the board',
  'Ocultas': 'Hidden',
  'Coronación': 'Promotion',
  'Preguntar siempre': 'Always ask',
  'Coronar dama automáticamente': 'Always promote to queen',
  'Cambiar contraseña': 'Change password',
  'Contraseña actual': 'Current password',
  'Nueva contraseña': 'New password',
  'Cambiando…': 'Changing…',
  'Contraseña actualizada. Se cerraron las demás sesiones.': 'Password updated. Your other sessions were signed out.',
  'No se pudo cambiar.': 'Could not change it.',

  // Página que no existe
  'Jugada ilegal': 'Illegal move',
  'Esta página no existe o se movió de casilla.': 'This page does not exist or has moved to another square.',
  'Volver al inicio': 'Back to home',

  // Tiempo relativo
  'hace un momento': 'just now',
  'hace {n} min': '{n} min ago',
  'hace {n} h': '{n} h ago',
  'hace {n} d': '{n} d ago',

  // De Zero a Hero
  'De Zero a Hero': 'From Zero to Hero',
  'Abrir Análisis': 'Open Analysis',
  'Abrir Aperturas': 'Open Openings',
  'Abrir Coordenadas': 'Open Coordinates',
  'Abrir Ejercicios': 'Open Puzzles',
  'Abrir Estudios': 'Open Studies',
  'Abrir el editor': 'Open the editor',
  'Ir a Jugar': 'Go to Play',
  'Continuar': 'Continue',
  'Empezar': 'Start',
  'Cúmplelo antes de pasar al siguiente nivel.': 'Complete it before moving on to the next level.',
  'Hito del nivel': 'Level milestone',
  'Inicia sesión': 'Sign in',
  'Juegan las blancas.': 'White to move.',
  'Juegan las negras.': 'Black to move.',
  'Lección {n}': 'Lesson {n}',
  'Nivel {n}': 'Level {n}',
  'Progreso': 'Progress',
  'Reintentar': 'Retry',
  'Ruta': 'Breadcrumb',
  'Sin sesión, el progreso se guarda en este navegador.': 'Without an account, progress is saved in this browser.',
  'Solución:': 'Solution:',
  'Ver solución': 'Show solution',
  'lecciones': 'lessons',
  'para llevarlo a tu cuenta.': 'to keep it in your account.',
  '{hechas} de {total} lecciones': '{hechas} of {total} lessons',
  '{n} min': '{n} min',
  '¡Correcto!': 'Correct!',
  'Anterior': 'Previous',
  'Completada': 'Completed',
  'Ejercicio': 'Exercise',
  'En el tablero': 'On the board',
  'Esa no es la mejor jugada. Vuelve a mirar la posición o pide una pista.': 'That is not the best move. Look at the position again or ask for a hint.',
  'Esa no es la mejor jugada. Vuelve a mirar la posición.': 'That is not the best move. Look at the position again.',
  'Esa también es buena. Seguimos con la línea principal:': 'That one is good too. We continue with the main line:',
  'Final': 'End',
  'No es esa. Piénsalo otra vez y elige otra opción.': 'Not that one. Think again and pick another option.',
  'Observa': 'Look',
  'Para recordar': 'Remember',
  'Paso {n}': 'Step {n}',
  'Ocultar ejercicio': "Hide exercise",
  'Repetir el ejercicio': "Repeat the exercise",
  'Ahora tú: hecho': "Your turn: done",
  'Ahora tú: ponlo en práctica': "Your turn: put it into practice",
  'Más práctica': "More practice",
  'Ahora tú · ejercicio {n} de {total}': "Your turn · exercise {n} of {total}",
  'Siguiente ejercicio': "Next exercise",
  'Lección guiada': "Guided lesson",
  'Aprende · paso {n} de {total}': "Learn · step {n} of {total}",
  'Ejercicio {n} de {total}': "Exercise {n} of {total}",
  'Ver ejercicios': "See exercises",
  'Atrás': "Back",
  'Aprende': "Learn",
  'Las flechas del tablero te señalan el movimiento o la idea. Usa los botones de abajo para ver el ejemplo jugada a jugada.': "The arrows on the board point out the move or the idea. Use the buttons below the board to see the example move by move.",
  'Seguir aprendiendo': "Keep learning",
  'Pruébalo tú': "Try it yourself",
  'Listo, seguir leyendo': "Done, keep reading",
  'Cada concepto tiene su ejercicio: pulsa «Pruébalo tú» bajo el tablero. Para mover, toca la pieza y luego la casilla de destino.': "Every concept has its exercise: tap “Try it yourself” under the board. To move, tap the piece and then the destination square.",
  'Toca la pieza y luego la casilla de destino (o arrástrala).': "Tap the piece, then the destination square (or drag it).",
  'Pasos': 'Steps',
  'Pista:': 'Hint:',
  'Pregunta': 'Question',
  'Práctica en UAChess': 'Practice on UAChess',
  'Reiniciar': 'Restart',
  'Repetir': 'Repeat',
  'Siguiente': 'Next',
  'Siguiente lección': 'Next lesson',
  'Siguiente paso': 'Next step',
  'Usa las flechas para avanzar jugada a jugada.': 'Use the arrows to step through the moves.',
  'Ver pista': 'Show hint',
  '{n} de 3 estrellas': '{n} of 3 stars',
  '{n} niveles · {lecciones} lecciones · unas {horas} h': '{n} levels · {lecciones} lessons · about {horas} h',
  '{n} pasos': '{n} steps',
  '¡Bien! Sigue.': 'Good! Keep going.',
  '¡Lección completada!': 'Lesson completed!',
  '¡Perfecto!': 'Perfect!',
  '¡Resuelto!': 'Solved!',
  'Cargando…': 'Loading…',
  'No se pudo cargar la lección. Comprueba tu conexión.': 'The lesson could not be loaded. Check your connection.',
  'Practícala en el paso {n}': 'Practice it in step {n}',

  // Etiquetas y filtros de estudios
  'Etiquetas': 'Tags',
  'Etiquetas de {name}': 'Tags for {name}',
  'Todos': 'All',
  'Lado': 'Side',
  'Desde qué lado están pensados (el que predomina en sus capítulos)': 'Which side they are built from (the one most of their chapters use)',
  'Blancas': 'White',
  'Negras': 'Black',
  'Ambos lados': 'Both sides',
  'No se pudieron guardar las etiquetas.': 'The tags could not be saved.',
  'Quitar la etiqueta {tag}': 'Remove the tag {tag}',
  'Añadir etiqueta…': 'Add tag…',
  'Ningún estudio cumple el filtro': 'No study matches the filter',
  'Quitar filtros': 'Clear filters',
  // Pro-Tactics
  'Pro-Tactics': 'Pro-Tactics',
  'Al azar': 'Random',
  'Por tema': 'By theme',
  'Elegir a mano': 'Pick manually',
  'Amenazas, piezas sobrecargadas, debilidades, la idea de la combinación…': 'Threats, overloaded pieces, weaknesses, the idea of the combination…',
  'Anotado': 'Annotated',
  'Borrar anotación': 'Delete annotation',
  'Buscar por número, jugador, lugar o nombre': 'Search by number, player, place or name',
  'Diagrama {n}': 'Diagram {n}',
  'Entra para usar Pro-Tactics': 'Sign in to use Pro-Tactics',
  'Grupo': 'Group',
  'Guardado': 'Saved',
  'Los diagramas de la Enciclopedia de combinaciones. Describe qué sucede en cada posición y ponle un nombre.': 'The diagrams of the Encyclopedia of Chess Combinations. Describe what is going on in each position and give it a name.',
  'Ningún diagrama cumple el filtro': 'No diagram matches the filter',
  'Ocultar solución': 'Hide solution',
  'Partida sin nombres': 'Game without names',
  'Por ejemplo: sacrificio en h7 y mate con torre': 'For example: sacrifice on h7 and rook mate',
  'Primera jugada': 'First move',
  'Última jugada': 'Last move',
  'Pro-Tactics es solo para cuentas VIP': 'Pro-Tactics is for VIP accounts only',
  'Sin guardar': 'Unsaved',
  'Solo los que he anotado': 'Only the ones I annotated',
  'Tema': 'Theme',
  'Todos los grupos': 'All groups',
  'Todos los temas': 'All themes',
  'Ver solución del libro': 'Show the book solution',
  'Volver a la lista': 'Back to the list',
  '{desde}–{hasta} de {total}': '{desde}–{hasta} of {total}',
  '{hechos} de {total} anotados': '{hechos} of {total} annotated',
  '¿Borrar tu anotación de este diagrama?': 'Delete your annotation for this diagram?',
  '¿Qué sucede en la posición?': 'What is going on in the position?',
  'Destrucción de la defensa': 'Annihilation of defence',
  'Bloqueo': 'Blockade',
  'Liberación de espacio': 'Clearance',
  'Desviación': 'Deflection',
  'Ataque descubierto': 'Discovered attack',
  'Clavada': 'Pin',
  'Demolición de la estructura de peones': 'Demolition of pawn structure',
  'Atracción': 'Decoy',
  'Intercepción': 'Interference',
  'Doble ataque': 'Double attack',
  'Con ataque al rey': 'With an attack on the king',
  'Para lograr la igualdad': 'To reach equality',
  'Otras combinaciones': 'Other combinations',
  'Bloqueado': 'Locked',
  'Bloquear': 'Lock',
  'Bloquear: mueve y prueba líneas sin que se guarden': 'Lock: move and try lines without saving them',
  'Desbloquear: lo que muevas volverá a guardarse': 'Unlock: your moves will be saved again',
  'Borrar desde esta jugada': 'Delete from this move',
  'Borrar jugada': 'Delete move',
  'Buscar ejercicios': 'Search exercises',
  'Buscar por el nombre que les pusiste…': 'Search by the name you gave them…',
  'Convertir en línea principal': 'Make it the main line',
  'Línea principal': 'Main line',
  'Girar el tablero': 'Flip the board',
  'Motor de análisis': 'Analysis engine',
  'Motor': 'Engine',
  'Mueve en el tablero para abrir variantes y dibuja flechas con el botón derecho. Se guarda en tu cuenta.': 'Move on the board to open variations and draw arrows with the right button. It is saved to your account.',
  'No se pudo guardar': 'Could not save',
  'Profundidad {n}': 'Depth {n}',
  'Solución del libro': 'Book solution',
  '¿Volver a la solución del libro? Se borran tus variantes y flechas.': 'Go back to the book solution? Your variations and arrows will be deleted.',
  'Modo práctica: mueve sin miedo, nada se guarda. Las líneas nuevas salen en amarillo; al final de cada una puedes incluirla en tu análisis.': 'Practice mode: move freely, nothing is saved. New lines show in yellow; at the end of each one you can add it to your analysis.',

  // Pro-Endgames
  'Pro-Endgames': 'Pro-Endgames',
  'Entra para usar Pro-Endgames': 'Sign in to use Pro-Endgames',
  'Pro-Endgames es solo para cuentas VIP': 'Pro-Endgames is for VIP accounts only',
  'Los diagramas de Comprehensive Chess Endings, de Averbakh. Describe qué sucede en cada posición y ponle un nombre.': 'The diagrams of Averbakh’s Comprehensive Chess Endings. Describe what is going on in each position and give it a name.',
  'Finales de alfil y de caballo': 'Bishop and knight endings',
  'Alfil contra caballo y torre contra pieza menor': 'Bishop against knight and rook against minor pieces',
  'Otros finales': 'Other endgames',
  'Finales de peones': 'Pawn endings',
  'Finales de torre': 'Rook endings',
  'Por tomo': 'By volume',
  'Tomo': 'Volume',
  'Todos los tomos': 'All volumes',
  'Tomo {n}': 'Volume {n}',
  'Por ejemplo: oposición y entrada del rey por d5': 'For example: opposition and king entry on d5',
  'Plan, casillas clave, oposición, zugzwang, victoria o tablas…': 'Plan, key squares, opposition, zugzwang, win or draw…',
  'Diagrama {n} del tomo {v}': 'Diagram {n} of volume {v}',
  'página {p}': 'page {p}',

  // Entrenador de estudios
  'Este estudio todavía no tiene líneas con jugadas tuyas. Añade jugadas al estudio para poder entrenarlas.': 'This study has no lines with moves for you yet. Add moves to the study to train them.',
  '{n} de {total} líneas dominadas': '{n} of {total} lines mastered',
  '{n} por repasar': '{n} due for review',
  'Orden': 'Order',
  'Las flojas primero': 'Weakest first',
  'En el orden del estudio': 'In study order',
  'Línea completa, sin errores.': 'Line complete, no mistakes.',
  'Línea completa. Errores: {n}. Se repasará pronto.': 'Line complete. Mistakes: {n}. It will come back soon.',
  'Línea completa, pero con ayuda. Se repasará pronto.': 'Line complete, but with help. It will come back soon.',
  '{san} no es la jugada del estudio. Prueba otra.': '{san} is not the study move. Try another.',
  'Tu turno: juega la jugada del estudio.': 'Your turn: play the study move.',
  'Responde la máquina…': 'The machine is replying…',
  'Pista': 'Hint',
  'Mostrar la jugada': 'Show the move',
  'Empezar de nuevo': 'Start over',
  'Siguiente línea': 'Next line',
  'Seguir contra la máquina': 'Keep playing the machine',
  'Marcar esta posición como clave para entrenarla aparte': 'Mark this position as key to train it separately',
  'Posición clave': 'Key position',
  'Marcar como clave': 'Mark as key',
  'Mostrar los comentarios del estudio': 'Show the study comments',
  'Líneas': 'Lines',
  'Dominada': 'Mastered',
  'En aprendizaje': 'Learning',
  'Nueva': 'New',
  'Todavía no has marcado ninguna posición. En el repaso de líneas, pulsa «Marcar como clave».': 'You have not marked any position yet. While reviewing lines, press “Mark as key”.',
  'No hay posiciones clave en este alcance: aparecen donde el estudio ofrece varias opciones, comentarios o jugadas destacadas.': 'There are no key positions here: they appear where the study offers several options, comments or highlighted moves.',
  'Ver todas las posiciones clave': 'See all key positions',
  '{n} de {total} dominadas': '{n} of {total} mastered',
  'Solo las que he marcado': 'Only the ones I marked',
  'Quitar la marca': 'Remove the mark',
  '¿Qué idea hay en esta posición?': 'What is the idea in this position?',
  'Plan, amenazas, por qué esta jugada y no otra… (se guarda en tu cuenta)': 'Plan, threats, why this move and not another… (saved to your account)',
  'Esta volverá pronto.': 'This one will come back soon.',
  '¡Correcto! Jugada del estudio.': 'Correct! Study move.',
  'Juega la jugada del estudio, o escribe tu idea y mira la solución.': 'Play the study move, or write your idea and look at the solution.',
  'Solución del estudio': 'Study solution',
  'línea principal': 'main line',
  'alternativa': 'alternative',
  'Cualquiera de ellas cuenta como acierto.': 'Any of them counts as correct.',
  'Jaque mate: ha ganado la máquina.': 'Checkmate: the machine won.',
  '¡Jaque mate! Has ganado.': 'Checkmate! You won.',
  'Tablas.': 'Draw.',
  'Capítulo': 'Chapter',
  'Nivel de la máquina': 'Machine level',
  'Has llegado al final del estudio. A partir de aquí juega la máquina: aplica lo aprendido.': 'You reached the end of the study. From here the machine plays: apply what you learned.',
  'Estás dentro del estudio.': 'You are following the study.',
  'Te saliste del estudio con {san}; el estudio seguía con {expected}.': 'You left the study with {san}; the study continued with {expected}.',
  'Fuera del estudio: juega la máquina.': 'Out of the study: the machine plays.',
  'Pensando…': 'Thinking…',
  'Deshacer': 'Undo',
  'Ver la jugada del estudio': 'See the study move',
  'Jugar con el otro color': 'Play the other colour',
  'Cambiar de color': 'Switch colour',
  'Jugadas': 'Moves',
  'Aún no hay jugadas.': 'No moves yet.',
  'Las jugadas en gris ya no son del estudio.': 'Moves in grey are no longer from the study.',
  'No se pudo cargar el estudio.': 'The study could not be loaded.',
  'Ver todos los estudios': 'See all studies',
  'Volver al estudio': 'Back to the study',
  'Entrenar': 'Train',
  'Repasa las líneas contra la máquina, practica las posiciones clave y juega desde el estudio hasta dominarlo.': 'Review the lines against the machine, practise the key positions and play from the study until you master it.',
  'Capítulos': 'Chapters',
  'Todo el estudio': 'Whole study',
  'Repasar líneas': 'Review lines',
  'Posiciones clave': 'Key positions',
  'Contra la máquina': 'Against the machine',
  'Este estudio no tiene capítulos.': 'This study has no chapters.',
  'Entrenar este estudio': 'Train this study',
  'Entrenar {name}': 'Train {name}',
  'Entrenar las líneas y posiciones clave con la máquina': 'Train the lines and key positions with the machine',
  'Hay varias opciones': 'Several options',
  'Con explicación': 'With explanation',
  'Jugada destacada': 'Highlighted move',
  'Marcada por ti': 'Marked by you',
  'Principiante': 'Beginner',
  'Aficionado': 'Amateur',
  'De club': 'Club player',
  'Fuerte': 'Strong',
  'Desbloquear: lo que muevas volverá a guardarse en el estudio': 'Unlock: what you move will be saved to the study again',
  'Bloquear: mueve y prueba líneas sin que se guarden en el estudio': 'Lock: move and try lines without saving them to the study',
  'Modo práctica: mueve sin miedo, las jugadas salen en amarillo y no se guardan en el estudio.': 'Practice mode: move freely, moves show in yellow and are not saved to the study.',
  'Desbloqueado: las jugadas que hagas se guardan en el estudio.': 'Unlocked: the moves you make are saved to the study.',
  'Siguiente jugada': 'Next move',
  'Ver la jugada': 'Play the move',
  'Otro ejemplo': 'Another example',
  'Siguiente idea': 'Next idea',
  'Juegan blancas': 'White to move',
  'Juegan negras': 'Black to move',
  'Idea {n} de {total}': 'Idea {n} of {total}',
  'Ejemplos': 'Examples',
  'Ejemplo {n}': 'Example {n}',
  'Ya lo has visto': 'Already seen',
  'Material': 'Material',
  'blancas': 'White',
  'negras': 'Black',
  'igualados': 'level',
  '{bando} con {n} de ventaja': '{bando} ahead by {n}',
  // Portada
  'O resuelve un ejercicio sin registrarte': 'Or solve a puzzle without signing up',
  'Morphy contra el duque de Brunswick y el conde Isouard, París 1858': 'Morphy vs. the Duke of Brunswick and Count Isouard, Paris 1858',
  '17. Td8#': '17. Rd8#',

  // Portada con sesión (panel)
  '{n} en vivo': '{n} live',
  'Ahora mismo no hay partidas en directo.': 'No live games right now.',
  'Amigos conectados': 'Friends online',
  'Buscar o invitar amigos': 'Find or invite friends',
  'Duración {n} min': '{n} min long',
  'En directo': 'Live',
  'En juego': 'In progress',
  'En línea': 'Online',
  'En {n} min': 'In {n} min',
  'Estable': 'Steady',
  'Juegan {side}': '{side} to move',
  'Jugadas recientes': 'Recent moves',
  'Más ritmos': 'More time controls',
  'Ninguno de tus amigos está conectado ahora.': 'None of your friends are online right now.',
  'No hay torneos programados ahora mismo.': 'No tournaments scheduled right now.',
  'Próximos torneos': 'Upcoming tournaments',
  'Racha de táctica': 'Puzzle streak',
  'Resueltos esta semana': 'Solved this week',
  'Resuelve ejercicios cada día para que la semana quede completa.': 'Solve puzzles every day to complete the week.',
  'Retar': 'Challenge',
  'Récord: {n}': 'Best: {n}',
  'Sala de espera': 'Lobby',
  'Sala de espera ({n} reto)': 'Lobby ({n} seek)',
  'Sala de espera ({n} retos)': 'Lobby ({n} seeks)',
  'Sin jugadas todavía.': 'No moves yet.',
  'Terminada': 'Finished',
  'Unirse': 'Join',
  'Ver en UAChess TV': 'Watch on UAChess TV',
  'Ver la partida': 'View game',
  'Ver todo': 'View all',
  '{d} esta semana': '{d} this week',
  '{n} acierto': '{n} solved',
  '{n} aciertos': '{n} solved',
  '{n} conectado': '{n} online',
  '{n} conectados': '{n} online',
  '{n} en línea': '{n} online',
  '{n} inscrito': '{n} player',
  '{n} inscritos': '{n} players',
  '{n} jugador conectado': '{n} player online',
  '{n} jugadores conectados': '{n} players online',
  '{n} partida': '{n} game',
  '{n} partidas': '{n} games',
  '{n} partida en juego': '{n} game in progress',
  '{n} partidas en juego': '{n} games in progress',
  'Buenos días, {name}': 'Good morning, {name}',
  'Buenas tardes, {name}': 'Good afternoon, {name}',
  'Buenas noches, {name}': 'Good evening, {name}',
  'Sin cambios esta semana': 'No change this week',
  'acierto seguido': 'in a row',
  'aciertos seguidos': 'in a row',
  'Ajedrez completo y sin anuncios': 'Complete chess, no ads',
  'Experiencia de gran maestro': 'A grandmaster experience',
  'Análisis de gran maestro con Stockfish': 'Grandmaster-level analysis with Stockfish',
  // Torneos, Comunidades y TV
  'Estado': 'Status',
  'Minutos': 'Minutes',
  'Incremento (s)': 'Increment (s)',
  'Torneos de ajedrez': 'Chess tournaments',
  'Arenas en vivo, torneos suizos y eliminatorias en tiempo real': 'Live arenas, Swiss tournaments and knockouts in real time',
  'Refrescar lista': 'Refresh list',
  'Crear torneo': 'Create tournament',
  'Entra para participar': 'Sign in to take part',
  'Próximos': 'Upcoming',
  'Finalizados': 'Finished',
  'Actualización automática': 'Updates automatically',
  'Buscar torneo por nombre, club o ganador...': 'Search by name, club or winner…',
  'Formato: Todos': 'Format: all',
  'Arenas': 'Arenas',
  'Suizos': 'Swiss',
  'Eliminatorias': 'Knockouts',
  'Ritmo: Todos': 'Time control: all',
  'Bala': 'Bullet',
  'Clásica': 'Classical',
  'Acceso: Todos': 'Access: all',
  'Públicos': 'Public',
  'Privados con clave': 'Private with password',
  'Con filtros de entrada': 'With entry requirements',
  'Limpiar filtros': 'Clear filters',
  'Limpiar': 'Clear',
  'Cargando torneos...': 'Loading tournaments…',
  'En juego ahora': 'Playing now',
  'Empieza pronto': 'Starting soon',
  'Puntuable': 'Rated',
  'jugador inscrito': 'player registered',
  'jugadores inscritos': 'players registered',
  'Club: {name}': 'Club: {name}',
  'Tiempo restante': 'Time left',
  'Comienza en': 'Starts in',
  'En curso': 'In progress',
  'Entrar a jugar': 'Play',
  'Inscribirme': 'Join',
  'Terminado': 'Finished',
  '{n} rondas': '{n} rounds',
  'Amistoso': 'Casual',
  'Amistosa': 'Casual',
  'solo miembros': 'members only',
  'Campeón:': 'Winner:',
  'Duración: {n} min': 'Length: {n} min',
  'Resultados': 'Results',
  'No se encontraron torneos': 'No tournaments found',
  'No hay torneos que coincidan con la búsqueda o los filtros aplicados.': 'No tournaments match your search or filters.',
  'No hay torneos programados próximamente': 'No upcoming tournaments',
  'Sé el primero en crear uno. Puedes elegir el ritmo, duración y condiciones que prefieras.': 'Be the first to create one. You choose the time control, length and entry rules.',
  'No hay torneos en juego ahora mismo': 'No tournaments in progress right now',
  'Consulta los próximos torneos para apuntarte o crea tu propia sala.': 'Check the upcoming tournaments to sign up, or create your own.',
  'Aún no hay torneos finalizados': 'No finished tournaments yet',
  'Cuando se completen competiciones en la plataforma, aquí podrás consultar sus podios e historiales.': 'Once tournaments finish, you\'ll find their podiums and results here.',
  'No hay torneos registrados': 'No tournaments yet',
  'Crea el primer torneo de la comunidad.': 'Create the community\'s first tournament.',
  'Privado con clave': 'Private with password',
  'Privado': 'Private',
  'Femenino': 'Women',
  'Masculino': 'Men',
  '{min}–{max} años': 'Ages {min}–{max}',
  '≥ {n} partidas': '≥ {n} games',
  'Arena de UAChess': 'UAChess Arena',
  'Indica cuándo empieza.': 'Choose when it starts.',
  'No se pudo crear el torneo.': 'The tournament couldn\'t be created.',
  'Torneo exclusivo para miembros del club': 'Tournament for club members only',
  'Organiza una competición para la comunidad': 'Organise a competition for the community',
  'Nombre del torneo': 'Tournament name',
  'Descripción y normas (opcional)': 'Description and rules (optional)',
  'Premios, normas, a quién va dirigido…': 'Prizes, rules, who it\'s for…',
  'Formato de competición': 'Format',
  'Ritmo de juego': 'Time control',
  'Duración total (minutos)': 'Total length (minutes)',
  'Número de rondas': 'Number of rounds',
  'Fecha y hora de inicio': 'Start date and time',
  'Las partidas cuentan para el rating oficial': 'Games count towards your rating',
  'Permitir berserk (jugar con la mitad del tiempo por 1 punto extra)': 'Allow berserk (play with half the time for 1 extra point)',
  'Condiciones y filtros de entrada': 'Entry requirements',
  'Opcional': 'Optional',
  'Acceso y privacidad': 'Access and privacy',
  'Público': 'Public',
  'Contraseña de acceso': 'Entry password',
  'Ej. ajedrez2026 (requerida para apuntarse)': 'e.g. chess2026 (needed to join)',
  'Solo los jugadores que introduzcan esta clave podrán entrar al torneo.': 'Only players who enter this password can join.',
  'Límite de Elo': 'Rating limit',
  'Elo mínimo': 'Minimum rating',
  'Sin mínimo': 'No minimum',
  'Elo máximo': 'Maximum rating',
  'Sin máximo': 'No maximum',
  'Categoría de género / sexo': 'Gender category',
  'Categoría por edad': 'Age category',
  'Todas las edades (Sin límite)': 'All ages (no limit)',
  'Sub-10 (Hasta 10 años)': 'Under 10 (up to 10 years old)',
  'Sub-12 (Hasta 12 años)': 'Under 12 (up to 12 years old)',
  'Sub-14 (Hasta 14 años)': 'Under 14 (up to 14 years old)',
  'Sub-16 (Hasta 16 años)': 'Under 16 (up to 16 years old)',
  'Sub-18 (Hasta 18 años)': 'Under 18 (up to 18 years old)',
  'Senior +50 (A partir de 50 años)': 'Senior 50+ (50 and over)',
  'Senior +65 (A partir de 65 años)': 'Senior 65+ (65 and over)',
  'Personalizado (definir edades)...': 'Custom (set ages)…',
  'Edad mínima': 'Minimum age',
  'Ej. 18': 'e.g. 18',
  'Edad máxima': 'Maximum age',
  'Ej. 30': 'e.g. 30',
  'Partidas jugadas en la plataforma': 'Games played on UAChess',
  'Filtro anti-smurfs': 'Keeps out smurf accounts',
  'Solo podrán entrar los miembros del club.': 'Only club members can join.',
  'Creando…': 'Creating…',
  'Crear y entrar': 'Create and enter',
  'Hoy a las {time}': 'Today at {time}',
  'Mañana a las {time}': 'Tomorrow at {time}',
  'Ayer a las {time}': 'Yesterday at {time}',
  '{date} a las {time}': '{date} at {time}',
  '¡Comenzando ahora!': 'Starting now!',
  'En {m}m {s}s': 'In {m}m {s}s',
  'En {n} h': 'In {n} h',
  'En {n} días': 'In {n} days',
  '{n} torneo registrado': '{n} tournament',
  '{n} torneos registrados': '{n} tournaments',
  '{n} jugador': '{n} player',
  '{n} jugadores': '{n} players',
  'Arena': 'Arena',
  'Emparejamiento continuo': 'Continuous pairing',
  'Suizo': 'Swiss',
  'Rondas fijas': 'Fixed rounds',
  'Eliminatoria': 'Knockout',
  'Quien pierde, fuera': 'Lose and you\'re out',
  'Abierto': 'Open',
  'Sub-1500': 'Under 1500',
  'Sub-1800': 'Under 1800',
  'Sub-2000': 'Under 2000',
  'Personalizado': 'Custom',
  'Abierto a todos': 'Open to everyone',
  '♀ Femenino': '♀ Women',
  'Solo mujeres': 'Women only',
  '♂ Masculino': '♂ Men',
  'Solo hombres': 'Men only',
  '≥ 5 partidas': '≥ 5 games',
  '≥ 10 partidas': '≥ 10 games',
  '≥ 20 partidas': '≥ 20 games',
  '≥ 50 partidas': '≥ 50 games',
  'Clubes y asociaciones de UAChess': 'UAChess clubs and associations',
  'Comunidades de UAChess': 'UAChess communities',
  'Únete a un club oficial, compite en ligas con ascensos y descensos, disputa torneos inter-clubes y forja tu legado en la clasificación interna.': 'Join a club, compete in leagues with promotion and relegation, play inter-club tournaments and climb your club\'s leaderboard.',
  'Cerrar formulario': 'Close form',
  'Crear club o asociación': 'Create club or association',
  'Entra para crear tu club': 'Sign in to create your club',
  'Ligas privadas': 'Private leagues',
  'Por temporadas': 'By season',
  'Suizo y arena': 'Swiss and arena',
  'Elo interno': 'Club rating',
  'Asociaciones': 'Associations',
  'Federaciones': 'Federations',
  'Todas las comunidades': 'All communities',
  'Mis clubes': 'My clubs',
  'Clubes': 'Clubs',
  'Buscar asociaciones…': 'Search associations…',
  'Buscar clubes…': 'Search clubs…',
  'Buscar por nombre o descripción…': 'Search by name or description…',
  'Limpiar búsqueda': 'Clear search',
  'No se encontraron comunidades': 'No communities found',
  'No perteneces a ninguna asociación': 'You\'re not in any association',
  'Aún no hay asociaciones federadas registradas': 'No associations yet',
  'Aún no formas parte de ningún club': 'You haven\'t joined a club yet',
  'Aún no hay clubes de ajedrez registrados': 'No chess clubs yet',
  'No hay coincidencias para «{query}». Prueba con otros términos o crea una nueva comunidad.': 'Nothing matches “{query}”. Try other words or create a new community.',
  'Los clubes tienen sus propios torneos, ligas por temporadas con ascensos y descensos, y una clasificación interna independiente del rating global.': 'Clubs have their own tournaments, seasonal leagues with promotion and relegation, and a club leaderboard separate from your overall rating.',
  'Crear la primera comunidad': 'Create the first community',
  'Asociación': 'Association',
  'Club oficial': 'Club',
  'Comunidad de ajedrez en UAChess.': 'A chess community on UAChess.',
  'Tuya': 'Yours',
  'Tu club': 'Your club',
  'Miembro': 'Member',
  'Ver club': 'View',
  'Indica un nombre para la comunidad.': 'Give the community a name.',
  'No se pudo crear la comunidad.': 'The community couldn\'t be created.',
  'Nueva asociación': 'New association',
  'Nuevo club de ajedrez': 'New chess club',
  'Configura los detalles principales de tu comunidad oficial.': 'Set up the main details of your community.',
  'Tipo de comunidad': 'Type of community',
  'Nombre de la asociación': 'Association name',
  'Nombre del club': 'Club name',
  'Asociación de Ajedrez de Madrid': 'Madrid Chess Association',
  'Club de Ajedrez Kasparov': 'Kasparov Chess Club',
  'Descripción de la comunidad': 'Community description',
  'Quiénes somos, días de juego, torneos y eventos que organizamos…': 'Who you are, when you play, tournaments and events you run…',
  'Emblema del club': 'Club emblem',
  'Emblema actual: {emblem}. Pulsa para cambiarlo': 'Current emblem: {emblem}. Tap to change it',
  'Elige un emoji representativo': 'Pick an emoji that represents you',
  'Podrás personalizar el fondo y subir una foto desde la configuración.': 'You can change the background and upload a photo later in the settings.',
  'Política de admisión': 'Who can join',
  'Crear asociación': 'Create association',
  'Crear club': 'Create club',
  '{n} miembro': '{n} member',
  '{n} miembros': '{n} members',
  'Por solicitud': 'On request',
  'Por invitación': 'By invitation',
  'Club de ajedrez': 'Chess club',
  'Comunidad de jugadores, torneos y ligas': 'Players, tournaments and leagues',
  'Asociación federada': 'Association',
  'Agrupa jugadores y clubes afiliados': 'Brings together players and member clubs',
  'Cualquiera entra directamente': 'Anyone can join straight away',
  'El administrador aprueba': 'An admin approves',
  'Solo miembros invitados': 'Invited members only',
  'Buscando partidas en directo': 'Looking for live games',
  'Canal': 'Channel',
  'Cuadrícula': 'Grid',
  'Repetición en tiempo real': 'Real-time replay',
  'Cargando Stockfish…': 'Loading Stockfish…',
  'Evaluación en directo': 'Live evaluation',
  'profundidad {n}': 'depth {n}',
  'quitar': 'hide',
  'Mostrar la evaluación de Stockfish': 'Show Stockfish evaluation',
  'Repetición': 'Replay',
  'Partida terminada. Buscando la siguiente…': 'Game over. Finding the next one…',
  'Juegan blancas.': 'White to move.',
  'Juegan negras.': 'Black to move.',
  'Ver la partida completa': 'See the full game',
  'Acaba de empezar.': 'Just started.',
  'No hay nada en directo en este canal': 'Nothing live on this channel',
  'UAChess TV muestra las partidas más interesantes que se están jugando ahora mismo. En cuanto empiece una, aparecerá aquí sola.': 'UAChess TV shows the most interesting games being played right now. As soon as one starts, it will appear here.',
  'Top Rating': 'Top rated',
  'Simultáneas': 'Simuls',
  'Correspondencia': 'Correspondence',
  // Avisos al móvil
  'Avisos en este dispositivo': 'Notifications on this device',
  'No se han podido activar. Vuelve a intentarlo.': 'Couldn’t turn them on. Please try again.',
  'En iPhone y iPad, primero añade UAChess a la pantalla de inicio (Compartir → Añadir a inicio) y ábrela desde ahí.': 'On iPhone and iPad, first add UAChess to your Home Screen (Share → Add to Home Screen) and open it from there.',
  'Los has bloqueado en el navegador. Permite las notificaciones de este sitio desde los ajustes del navegador.': 'You’ve blocked them in your browser. Allow notifications for this site in your browser settings.',
  'Este navegador no admite avisos.': 'This browser doesn’t support notifications.',
  'Te avisamos cuando te toca en una partida por correspondencia, te retan, empieza tu torneo o te escriben. Solo en este dispositivo.': 'We’ll let you know when it’s your move in a correspondence game, someone challenges you, your tournament starts or you get a message. This device only.',
  'Recibir estos avisos en el móvil': 'Get these notifications on your phone',
};

export default en;
